export const adExtension = {
  AdExtensionByKeywordReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Keyword',
      'AdExtensionType',
      'ClickType',
      'Impressions',
      'Clicks',
      'TotalClicks',
      'CTR',
      'Conversions',
      'AverageCPC',
      'ConversionRate',
      'Spend',
      'CostPerConversion',
    ],
    mandatory: [
      'AdExtensionType',
      'Keyword',
    ],
  },
  AdExtensionByAdReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdType',
      'AdTitle',
      'TitlePart1',
      'TitlePart2',
      'TitlePart3',
      'AdExtensionType',
      'ClickType',
      'Impressions',
      'Clicks',
      'CTR',
      'Conversions',
      'AverageCPC',
      'ConversionRate',
      'Spend',
      'CostPerConversion',
    ],
    mandatory: [
      'AdExtensionType',
    ],
  },
  AdExtensionDetailReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdExtensionType',
      'AdExtensionTypeId',
      'AdExtensionId',
      'AdExtensionPropertyValue',
      'Impressions',
      'Clicks',
      'CTR',
      'Conversions',
      'CostPerConversion',
      'ConversionRate',
      'Spend',
      'AverageCPC',
    ],
    mandatory: [
      'AdExtensionType',
      'AdExtensionTypeId',
      'AdExtensionId',
      'AdExtensionPropertyValue',
    ],
  },
  CallDetailReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'StartTime',
      'EndTime',
      'Duration',
    ],
    mandatory: [
      'StartTime',
      'EndTime',
    ],
  },
};
